"use client";

import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import styles from "./home.module.css";

const blogPostsWithContent = [
  { slug: "10-time-saving-online-tools-for-productivity", key: "blogPost1Title" },
  { slug: "how-to-optimize-images-for-web", key: "blogPost2Title" },
];

export default function BlogPreviewSection() {
  const t = useTranslations("home");
  return (
    <section className={styles.blogPreviewSection} aria-labelledby="blog-preview-heading">
      <div className="container-md">
        <h2 id="blog-preview-heading" className={styles.sectionTitle}>
          {t("blogPreviewTitle")}
        </h2>
        <p className={styles.sectionDescription}>{t("blogPreviewDescription")}</p>
        <ul className={styles.blogPreviewList}>
          {blogPostsWithContent.map(({ slug, key }) => (
            <li key={slug}>
              <Link href={`/blog/${slug}`} className={styles.blogPreviewLink}>
                {t(key)}
              </Link>
            </li>
          ))}
        </ul>
        <p className={styles.blogPreviewCta}>
          <Link href="/blog" className={styles.blogPreviewCtaLink}>
            {t("blogPreviewViewAll")}
          </Link>
        </p>
      </div>
    </section>
  );
}
